// extracted by mini-css-extract-plugin
module.exports = {"headerLogoBox":"style_headerLogoBox__2gmwz","headerLogo":"style_headerLogo__3YAC3","title":"style_title__3nXKT"};